import { ConfigType } from '../utils/requestAPI';

type CreateContractType = {
  clientId?: string;
  proposalId?: string;
  jobId?: string;
  startDate?: string;
  endDate?: string;
  notes?: string;
};

type GetContractsParamsType = {
  page?: number;
  limit?: number;
  search?: string;
};
type updateContractStatusType = {
  status: string;
};
const contractApi = {
  createContract: (data: CreateContractType): ConfigType => {
    return {
      url: '/contracts',
      method: 'post',
      data: data,
    };
  },
  getAllContract: (params: GetContractsParamsType): ConfigType => {
    return {
      url: '/contracts/lists-contracts-by-role',
      method: 'get',
      params,
      config: { store: { action: 'set', key: 'contracts.data' } },
    };
  },
  getContractDetails: (id: string): ConfigType => {
    return {
      url: `/contracts/${id}`,
      method: 'get',

      config: { store: { action: 'set', key: 'contractDetails' } },
    };
  },
  updateContractStatus: (
    id: string,
    data: updateContractStatusType
  ): ConfigType => {
    return {
      url: `/contracts/${id}`,
      method: 'patch',
      data: data,
    };
  },
};

export default contractApi;
